import { notification } from 'antd';

import { errorObjectToString } from '../common';

/**
 * Ant Design Form 검증 오류를 사용자 친화적인 메시지로 변환하여 알림을 표시하는 함수
 * @param error validateFields에서 발생한 오류 객체
 * @param fallbackMessage 기본 오류 메시지 (검증 오류가 아닌 경우 사용)
 * @returns 검증 오류인지 여부를 반환
 */
export const handleFormValidationError = (error: any, fallbackMessage = '오류가 발생했습니다'): boolean => {
  // validateFields 오류인지 확인
  if (error && typeof error === 'object' && 'errorFields' in error) {
    // Ant Design Form 검증 오류 처리
    const validationErrors = error.errorFields;
    const errorMessages = validationErrors
      .map((field: any) => `${field.name.join('.')}: ${field.errors.join(', ')}`)
      .join('\n');

    notification.error({
      message: '입력 정보를 확인해주세요',
      description: errorMessages,
    });

    return true; // 검증 오류임을 표시
  } else {
    // 기타 오류 처리
    const description = errorObjectToString(error);
    notification.error({
      message: fallbackMessage,
      description,
    });

    return false; // 검증 오류가 아님을 표시
  }
};

/**
 * Form 검증 오류 메시지만 추출하는 함수 (알림 표시 없이)
 * @param error validateFields에서 발생한 오류 객체
 * @returns 검증 오류 메시지 배열 또는 null
 */
export const extractFormValidationErrors = (error: any): string[] | null => {
  if (error && typeof error === 'object' && 'errorFields' in error) {
    const validationErrors = error.errorFields;
    return validationErrors.map((field: any) => `${field.name.join('.')}: ${field.errors.join(', ')}`);
  }
  return null;
};

/**
 * Form 검증 오류인지 확인하는 함수
 * @param error 확인할 오류 객체
 * @returns 검증 오류 여부
 */
export const isFormValidationError = (error: any): boolean => {
  return error && typeof error === 'object' && 'errorFields' in error;
};
